import React, { useState } from "react";
import { Card, CardBody, Col, Dropdown, DropdownMenu, DropdownToggle, Input, InputGroup } from "reactstrap";
import { Inputs, WithInputTypes } from "../../../../Constant";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { WITH_INPUT_DATA } from "../../../../Data/UiKit/Dropdown";
import { LI } from "../../../../AbstractElements";

const WithInputType = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);
  return (
    <Col xl="4" sm="6">
      <Card className="height-equal">
        <CommonCardHeader title={WithInputTypes} span={WITH_INPUT_DATA} />
        <CardBody className="rtl-dropdown">
          <div className="common-flex">
            <div className="btn-group">
              <Dropdown isOpen={open} toggle={toggle}>
                <DropdownToggle caret color="warning" className="text-white">{Inputs}</DropdownToggle>
                <DropdownMenu className="dropdown-block dropdown-wrapper dark-input-type">
                  <LI>
                    <InputGroup className="rounded-0 border-0 shadow-none">
                      <div className="input-group-text">
                        <Input className="form-check-input mt-0" type="checkbox" value="" />
                      </div>
                      <span>Default checkbox</span>
                    </InputGroup>
                    <InputGroup className="rounded-0 border-0 shadow-none">
                      <div className="input-group-text">
                        <Input className="form-check-input mt-0" type="radio" value="" />
                      </div>
                      <span>Default radio</span>
                    </InputGroup>
                  </LI>
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default WithInputType;
